import { createRoute } from "@tanstack/react-router";
import { AlertCircle } from "lucide-react";
import { Route as rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/link-expired",
  component: LinkExpiredPage,
});

/** Landing page shown when a patient opens a magic link that is expired or already used. */
function LinkExpiredPage() {
  return (
    <div className="flex min-h-screen flex-col items-center gap-4 px-6 text-center pt-[30vh]">
      <AlertCircle className="size-10 text-amber-500" />
      <h1 className="text-2xl font-semibold">This link has expired</h1>
      <p className="max-w-sm text-muted-foreground">
        This sign-in link has expired or has already been used. Try again with a new link.
      </p>
    </div>
  );
}
